import React from 'react';
export var SignUpTypes;
(function (SignUpTypes) {
    SignUpTypes["Link"] = "link";
    SignUpTypes["Contact"] = "contact";
    SignUpTypes["Internal"] = "internal";
})(SignUpTypes || (SignUpTypes = {}));
export var VOLUNTEER_ERROR;
(function (VOLUNTEER_ERROR) {
    VOLUNTEER_ERROR["VOLUNTEER_DOES_NOT_EXIST"] = "volunteer_does_not_exist";
})(VOLUNTEER_ERROR || (VOLUNTEER_ERROR = {}));
const notImplemented = () => {
    throw new Error('not implemented');
};
const VolunteerServiceContext = React.createContext({
    getVolunteer: notImplemented,
    registerVolunteer: notImplemented,
    registerAssignment: notImplemented,
    applyToAssignment: notImplemented,
    getAssignment: notImplemented,
});
export default VolunteerServiceContext;
